import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-pricing-faq',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, RouterModule],
  templateUrl: './pricing-faq.component.html',
  styleUrl: './pricing-faq.component.scss'
})
export class PricingFaqComponent {
  faqs = [
    {
      question: 'What plan is right for my organization?',
      answer:
        'Choose based on how you operate. Society is the complete MemberTrace platform for most independent associations and professional societies. Growth adds advanced permissions, integrations, a custom workflow (automation) builder, and advanced reporting. Automated dues renewal reminders are included on every plan. Operator is for teams responsible for multiple organizations.',
    },
    {
      question: 'What if my organization is too small for Society?',
      answer:
        'If you are evaluating MemberTrace, start with a 90-day trial. If you are forming a new organization, apply for the Launch Program. Paid MemberTrace starts at Society. The Launch Program is not a permanent free plan: eligibility ends after 12 months or 50 active members, whichever comes first.',
    },
    {
      question: 'Do I need Growth if my membership gets bigger?',
      answer:
        'No. Society includes 500 active members, then $1 per additional active member, billed monthly. A straightforward 600-member society can stay on Society plus overage—and add Managed Support if you want help doing the work. Choose Growth when you need advanced permissions, custom workflows, integrations, or advanced reporting, not because another member signed up. Growth can also become cheaper than Society plus overage around 800 members; that is an economic option, not a required upgrade.',
    },
    {
      question: 'Are automated renewal reminders included on Society?',
      answer:
        'Yes. Automated dues renewal reminder emails are included on every plan, including Society at $299/month. Growth adds a custom workflow builder for organizations that want to design their own automations beyond renewal reminders.',
    },
    {
      question: 'How does overage billing work?',
      answer:
        'Each plan includes a number of active members (500 on Society, 1,500 on Growth). Each active member above that is $1 per month, billed monthly with your subscription. There is no automatic plan change when you cross the allotment.',
    },
    {
      question: 'Do I need Operator if I only manage one society?',
      answer:
        'No. Operator is designed specifically for teams managing multiple organizations. Many independent societies and associations are best served by Society or Growth.',
    },
    {
      question: 'What is Managed Support?',
      answer:
        'Managed Support is an optional add-on from $499/month for organizations that want hands-on help with recurring MemberTrace administration, configuration, event setup, workflows, and other platform tasks. It is not a product tier, and it is not IT consulting or custom development.',
    },
    {
      question: 'Can I try MemberTrace for free?',
      answer:
        'Yes. Small organizations (up to 50 active members) can start a 90-day free trial: choose Society or Growth when you sign up and add a card on file—you will not be charged today. Newly forming organizations may qualify for the MemberTrace Launch Program. Established organizations typically start with Concierge Migration so their real data and workflows can be configured before go-live.',
    },
    {
      question: 'What is the MemberTrace Launch Program?',
      answer:
        'The Launch Program is designed for newly forming associations and societies building their initial membership. Applications are reviewed to ensure the program is a good fit. Participation lasts up to 12 months or until the organization reaches 50 active members, whichever comes first. It is not a permanent free plan.',
    },
    {
      question: 'Who qualifies for the MemberTrace Launch Program?',
      answer:
        'The Launch Program is designed for newly forming associations and societies building their initial membership. Applications are reviewed to ensure the program is a good fit. Participation lasts up to 12 months or until the organization reaches 50 active members, whichever comes first.',
    },
    {
      question: 'Do you help migrate data from another system?',
      answer:
        'Yes. Established organizations can use Concierge Migration, which includes guided data migration, configuration assistance, onboarding, and launch support. Pay when you\'re ready to go live.',
    },
    {
      question: 'Are payment-processing fees included?',
      answer:
        'No. Package pricing covers the MemberTrace platform. Card processing for dues, events, and other member payments uses Stripe and is charged at standard Stripe rates separately from your subscription. Online dues and event payments may also carry a small MemberTrace platform fee, a percentage of each payment, and processing and platform fees are not returned on refunds. Payments you record by check or cash are not charged either fee.',
    },
    {
      question: 'How is active membership calculated and updated?',
      answer:
        'Active members are current members who are dues-exempt or have paid dues in the last 12 months — not every historical contact in your database. Counts update from your live membership data for each billing period, so you pay for the members you are actually operating.',
    },
    {
      question: 'What does included support cover?',
      answer:
        'Included Support helps you use MemberTrace. Managed Support helps do the work inside MemberTrace. Every plan includes email, chat, and phone support, a knowledge base and onboarding docs, standard onboarding, issue resolution, and product guidance. Managed Support is a separate optional add-on.',
    },
    {
      question: 'What does standard onboarding include?',
      answer:
        'Standard onboarding covers guided setup of your organization, core membership and dues configuration, portal branding basics for your package, and training so your admins can run day-to-day operations. Complex data migration and custom integrations are scoped and quoted separately, or handled through Concierge Migration.',
    },
    {
      question: 'Can we import historical member and payment data?',
      answer:
        'Yes. Standard CSV and structured imports are part of onboarding. Larger historical archives, multi-system consolidations, and payment-history rebuilds are available through Concierge Migration or as scoped migration work when needed.',
    },
    {
      question: 'Is website hosting included?',
      answer:
        'Yes. Every package includes a hosted member portal with custom domain and full branding. Broader marketing websites outside the member portal can be discussed if you need them.',
    },
    {
      question: 'Are email and SMS usage included?',
      answer:
        'Transactional and operational member email for renewals, receipts, and notices is included for normal operating volumes. SMS and high-volume campaigns are available; we confirm fair-use or usage terms during your demo so expectations match how you communicate today.',
    },
    {
      question: 'Can we change packages later?',
      answer:
        'Yes. Self-serve packages are billed monthly with no long-term commitment, so you can move up or down as needs change. Annual agreements are available on request for Society and above when your board prefers a fixed yearly arrangement.',
    },
  ];
}
